export const headers = [
    'Email',
    'Tipo',
    'Sub Tipo',
    'Medio de Pago',
    'Monto',
    'Fecha de creación',
]

export const keyColumns = [
    'userEmail',
    'typeFormat',
    'subTypeFormat',
    'cashTypeFormat',
    'amount',
    'created',
];

export const columns = [
    {
        field: 'typeFormat',
        header: 'Tipo'
    },
    {
        field: 'subTypeFormat',
        header: 'Sub Tipo'
    },
    {
        field: 'cashTypeFormat',
        header: 'Medio de Pago'
    },
    {
        field: 'amount',
        header: 'Monto',
        type: 'money'
    },
    {
        field: 'created',
        header: 'Fecha de creación',
        type: 'date'
    },
    {
        field: 'userEmail',
        header: 'Email'

    },
]

export const title = 'Movimientos de caja';
export const titleImprest = 'Movimientos de fondo fijo';

export const movementTypes = {
    ingress: 'Ingress',
    egress: 'Egress',
}

export const movementTypesFormat = {
    Ingress: 'Ingreso',
    Egress: 'Egreso',
}

export const typesSelect = [
    { label: "Todos", value: "" },
    { label: movementTypesFormat.Ingress, value: movementTypes.ingress },
    { label: movementTypesFormat.Egress, value: movementTypes.egress },
]

export const subTypes = {
    Deposit: 'Deposit',
    Imprest: 'Imprest',
    Refund: 'Refund',
    Void: 'Void',
    Sale: 'Sale',
    Transfer: 'Transfer',
    InternalVoucher: 'InternalVoucher',
    Adjustment: 'Adjustment',
    Advance: 'Advance'
}

export const subTypesFormat = {
    Deposit: 'Depósito',
    Imprest: 'Fondo Fijo',
    Refund: 'Devolución',
    Void: 'Anulación',
    Sale: 'Venta',
    Transfer: 'Transferencia',
    InternalVoucher: 'Comprobante Interno',
    Adjustment: 'Ajuste'
}

export const subTypesSelect = [
    { label: "Todos", value: "" },
    { label: subTypesFormat.Deposit, value: subTypes.Deposit },
    { label: subTypesFormat.Imprest, value: subTypes.Imprest },
    { label: subTypesFormat.Refund, value: subTypes.Refund },
    { label: subTypesFormat.Void, value: subTypes.Void },
    { label: subTypesFormat.Sale, value: subTypes.Sale },
    { label: subTypesFormat.Transfer, value: subTypes.Transfer },
    { label: subTypesFormat.InternalVoucher, value: subTypes.InternalVoucher },
    { label: subTypesFormat.Adjustment, value: subTypes.Adjustment },
]

export const subTypesImprestSelect = [
    { label: "Todos", value: "" },
    { label: subTypesFormat.Imprest, value: subTypes.Imprest },
    { label: subTypesFormat.Transfer, value: subTypes.Transfer }
]

export const cashTypes = {
    cash: 'Cash',
    card: 'Card',
    qr: 'Qr',
    link: 'Link',
    check: 'Check',
    transfer: 'Transfer',
    terminalQr: 'TerminalQr'
}

export const cashTypesFormat = {
    CashUSD: 'Efectivo - USD',
    CashARS: 'Efectivo - ARS',
    CashUYU: 'Efectivo - UYU',
    CashCLP: 'Efectivo - CLP',
    Cash: 'Efectivo',
    Card: 'Tarjeta',
    Qr: 'Mercado Pago QR',
    Link: 'Mercado Pago',
    Check: 'Cheque',
    Transfer: 'Transferencia',
    TerminalQr: 'Terminal QR'
}

export const cashTypesSelect = [
    { value: cashTypes.cash, label: cashTypesFormat.Cash },
    { value: cashTypes.card, label: cashTypesFormat.Card },
    { value: cashTypes.qr, label: cashTypesFormat.Qr },
    { value: cashTypes.link, label: cashTypesFormat.Link },
    { value: cashTypes.check, label: cashTypesFormat.Check },
    { value: cashTypes.transfer, label: cashTypesFormat.Transfer },
    { value: cashTypes.terminalQr, label: cashTypesFormat.TerminalQr }
]

export const cashRegisterMovementModel = {
    id: 0,
    userEmail: '',
    type: '',
    cashType: '',
    reason: '',
    amount: '',
    observation: '',
    created: '',
    fileUrl: '',
    subType: '',
    bankAccountInfo: null,
    reasonId: null,
    files: [],
    externaNumber: null,
    externalPrefix: null,
    externaDate: null,
    bankAccount: null,
    bankAccountId: null
};

export const cardTypeFormat = {
    Credit: 'Credito',
    Debit: 'Debito'
}

export const subTypeSales = {
    Sale: 'Sale',
    Refund: 'Refund',
    Void: 'Void'
}

export const subTypesMovementFormat = {
    deposit: 'Depósito',
    imprest: 'Fondo Fijo',
    transfer: 'Transferencia',
    advance: 'Anticipo'
}

export const currencies = {
    usd: 'USD',
    ars: 'ARS',
    uyu: 'UYU',
}

export const currenciesFormat = {
    usd: 'Dolares',
    ars: 'Peso ARS',
    uyu: 'Peso UYU',
}

export const currenciesSelect = [
    { label: "Todas", value: "" },
    { value: currencies.usd, label: currenciesFormat.usd },
    { value: currencies.ars, label: currenciesFormat.ars },
    { value: currencies.uyu, label: currenciesFormat.uyu },
]